import { render, staticRenderFns } from "./account-footer.vue?vue&type=template&id=423ab79a&"
import script from "./account-footer.vue?vue&type=script&lang=js&"
export * from "./account-footer.vue?vue&type=script&lang=js&"
import style0 from "./account-footer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports